import styled from 'styled-components/macro';
import { Chip } from '@material-ui/core';
import { green, red } from '@material-ui/core/colors';
import { spacing, SpacingProps } from '@material-ui/system';

interface StyledChipProps extends SpacingProps {
  $active: boolean;
}

const StyledChip = styled(Chip)<StyledChipProps>`
  ${spacing};
  background: ${props => {
    return props.$active ? green[500] : red[500];
  }};
  color: ${props => props.theme.palette.common.white};
`;

export default StyledChip;
